exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow {\n  overflow-y: auto; }\n\n.no-overflow-x {\n  overflow-x: hidden; }\n\n.full-width {\n  width: 100%; }\n\n.full-height {\n  height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/cmcever/Documents/GitHub/ChallengerTurf/EPSePortal/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main